<div class="theme-steps">
  <app-header></app-header>
  <section class="page-header-title">
    <div class="page-title-overlay"></div>
    <img
      src="assets/images/w2c/bg-not-found.jpg"
      alt=""
      class="w-100 page-title-image"
    />
    <div class="page-header-title-caption">
      <h1>Not Found 404</h1>
    </div>
  </section>
  <section class="step4 inner-page-content error-page">
    <div class="container">
      <div class="privacy box-panel last-panel">
        <div class="row pt-2">
          <div class="col-md-12">
            <h4 *ngIf="!isPolicyStatus">
              The page you were looking for does not exist
            </h4>
            <p *ngIf="isPolicyStatus">
              <b
                >This quote is now converted to a policy and is no longer
                available.</b
              >
              You can either:
            </p>
            <p *ngIf="!isPolicyStatus">
              We could not find the page you requested. You can either:
            </p>
            <ul class="pay-disclaimer">
              <li>
                <a routerLink="/">Return to the homepage</a>
              </li>
              <li>
                Phone customer support on
                <strong>+61 2 9225 7599</strong>
              </li>
            </ul>
            <h4>Emergency assistance</h4>
            <p>
              In the event you need assistance when travelling you can call our
              Worldwide emergency assistance number:
            </p>
            <p>
              <strong
                ><a href="tel:+61 2 8055 1699"> +61 2 8055 1699</a></strong
              >
            </p>
          </div>
          <div class="col-md-12">
            <p>{{ errorMessage }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</div>
